/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Pain_Side_LeftInputs */

const en_us2_profile_editors_pain_side_left = /** @type {(inputs: Profile_Editors_Pain_Side_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Left`)
};

const pt_br2_profile_editors_pain_side_left = /** @type {(inputs: Profile_Editors_Pain_Side_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esquerdo`)
};

const es_419_profile_editors_pain_side_left = /** @type {(inputs: Profile_Editors_Pain_Side_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Izquierdo`)
};

const pt_pt2_profile_editors_pain_side_left = /** @type {(inputs: Profile_Editors_Pain_Side_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esquerdo`)
};

const fr_fr2_profile_editors_pain_side_left = /** @type {(inputs: Profile_Editors_Pain_Side_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gauche`)
};

const de_de2_profile_editors_pain_side_left = /** @type {(inputs: Profile_Editors_Pain_Side_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Links`)
};

const it_it2_profile_editors_pain_side_left = /** @type {(inputs: Profile_Editors_Pain_Side_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sinistro`)
};

/**
* | output |
* | --- |
* | "Left" |
*
* @param {Profile_Editors_Pain_Side_LeftInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_pain_side_left = /** @type {((inputs?: Profile_Editors_Pain_Side_LeftInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Pain_Side_LeftInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_pain_side_left(inputs)
	if (locale === "es-419") return es_419_profile_editors_pain_side_left(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_pain_side_left(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_pain_side_left(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_pain_side_left(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_pain_side_left(inputs)
	return en_us2_profile_editors_pain_side_left(inputs)
});
export { profile_editors_pain_side_left as "profile-editors.pain_side_left" }